import { jsx as _jsx } from "react/jsx-runtime";
import { Sort as CoreSort } from '@search/core/components/Sort';
import { useAppContext } from '../../contexts/AppContext';
export const SortTestId = 'serp-sort-testid';
export const Sort = () => {
    const [setOrder, order] = useAppContext((store) => [store.setOrder, store.order]);
    return _jsx(CoreSort, { order: order, setSort: setOrder, testId: SortTestId });
};
